import { render, staticRenderFns } from "./MotorOption.vue?vue&type=template&id=c8baa7f2"
import script from "./MotorOption.vue?vue&type=script&lang=js"
export * from "./MotorOption.vue?vue&type=script&lang=js"
import style0 from "./MotorOption.vue?vue&type=style&index=0&id=c8baa7f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports